import React from 'react';
//css
import './PaymentSummary.css';
import { AiOutlineDollar } from 'react-icons/ai';
//assets
import successLogo from '../../../assets/complete.png';
import incompleteLogo from '../../../assets/incomplete.png';
import ImageComponent from '../../../helpers/ImageComponent';
//helpers
import { getSymbolFromCurrency } from '../../../config/currencyConfig';
import { getPaymentIcon, showAmount } from '../../../config/paymentConfig';

export default function PaymentSummary({ currency, amount, status, paymentType, tokenNumber }) {
    return (
        <div className='payment-summary'>
            <div className='timeline-summary-left'>
                <span className='timeline-amount-text'>
                    <AiOutlineDollar size='24px' />
                    <p>Amount</p>
                </span>
                {showAmount(amount) && <span className='timeline-amount'>{getSymbolFromCurrency(currency)}{amount}</span>}
                <span className='timeline-status'>
                    {status === "SUCCESS" ? (
                        <span className='timeline-success-status'>
                            Succeeded
                            <ImageComponent sourceUrl={successLogo} details="successIcon" width="9px" height="9px" />
                        </span>
                    ) : (
                        <span className='timeline-incomplete-status'>
                            Incomplete
                            <ImageComponent sourceUrl={incompleteLogo} details="incompleteIcon" width="9px" height="9px" />
                        </span>
                    )}
                </span>
                <span className='summary-payment-type'>
                    <p>Payment Type: <span className='decorate-color'>{paymentType}</span></p>
                    {getPaymentIcon(paymentType)}
                </span>
            </div>
            <div className='timeline-summary-right'><p>Token Number: <span className='decorate-color'>{tokenNumber}</span></p></div>
        </div>
    )
}